import { apiUrl, appUrl, baseURL } from '@/apiConfig'
// const baseURLApi = 'http://api.chatway.lc'
// const baseURLApp = 'http://app.chatway.lc'
// const baseURLApi = 'https://api.chatway.ru'
// const baseURLApp = 'https://app.chatway.ru'
// const baseURL = baseURL

let params = {
    baseURLApi: apiUrl,
    baseURLApp: appUrl,
    appVkId: 7222883,
    loginAppVkId: 7147246,
    client_id: 6359918,
    urlToApi: apiUrl,
    message: {
        url: apiUrl + '/message'
    },
    mailing: {
        url: apiUrl + '/mailing'
    },
    module: {
        url: apiUrl + '/module'
    },
    event: {
        url: apiUrl + '/event'
    },
    client: {
        url: apiUrl + '/client'
    },
    module_group: {
        url: apiUrl + '/module_group'
    },
    user: {
        url: apiUrl + '/user'
    },
    bot: {
        url: apiUrl + '/bot'
    },
    stats: {
        url: apiUrl + '/stats'
    },
    vk_groups: {
        url: apiUrl + '/user'
    },
    jump: {
        url: apiUrl + '/jump'
    },
    jumpWorkUrl: {
        url: apiUrl + '/a'
    },
    job: {
        url: apiUrl + '/job'
    },
    baseURL: {
        url: baseURL + '/a'
    },
    app_vk: {
        url: apiUrl + '/app_vk'
    },
    api: {
        url: apiUrl + '/api'
    },
    tool: {
        url: apiUrl + '/tool'
    },
    leads: {
        url: apiUrl + '/leads'
    },
    scenarios: {
        url: apiUrl + '/scenarios'
    },
    post: {
        url: apiUrl + '/post'
    },
    shop: {
        url: apiUrl + '/shop'
    },
    secretClient: {
        url: apiUrl + '/secret-client'
    }
}

export default params
